import { render, staticRenderFns } from "./OpenCourse.vue?vue&type=template&id=cf724ada"
import script from "./OpenCourse.vue?vue&type=script&lang=ts"
export * from "./OpenCourse.vue?vue&type=script&lang=ts"
import style0 from "./OpenCourse.vue?vue&type=style&index=0&id=cf724ada&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports